var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',{attrs:{"center":"","name":"mapMarked","label":_vm.schema.label,"placeholder":_vm.schema.placeholder,"value":_vm.schema.value,"required":_vm.schema.required === true}},[_c('template',{slot:"button"},[_c('van-button',{attrs:{"size":"small","type":"primary","icon":"map-marked"}},[_vm._v("位置")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }